import { useEffect, useState } from "react";
import { useSession } from "./useSession";
import axios from "axios";

const useLog = () => {
    const {read, batchUpdate} = useSession();
    const addressSearchKeys = ["search", "selected", "addr_pos", "lat", "lon", "zip", "filiali"];
    const branchSelectionKeys = ["filiale_pos", "filiale_id", "filiale_name", "filiale_clicks", "date_clicks", "time_clicks", "elapsed"];
    const [log_elapsed, set_log_elapsed] = useState(new Date().getTime());
    const apiBaseUrl = "https://c0mp.as/api";

    useEffect(() => {
        cleanup();
    }, []);
    
    const addressSearchEvent = () => {
        const payload = {};
        for(let k of addressSearchKeys) {
            payload[k] = read(`log_${k}`)
        }

        console.log("/api/address-search-event", payload);
        axios.post(`${apiBaseUrl}/address-search-event`, payload).catch(() => {
            console.log("ux logs-1 not sent");
        });
    }
    const branchSelectionEvent = () => {
        const filiale = read("filialeScelta");
        const now = new Date().getTime();
        batchUpdate({
            log_elapsed: now - log_elapsed,
            log_filiale_pos: read("filialeSceltaIdx"),
            log_filiale_id: filiale.codFiliale,
            log_filiale_name: filiale.nomeFiliale || filiale.RagioneSociale
        });

        const payload = {};
        for(let k of addressSearchKeys.concat(branchSelectionKeys)) {
            payload[k] = read(`log_${k}`)
        }

        console.log(`/api/branch-selection-event`, payload);        
        axios.post(`${apiBaseUrl}/branch-selection-event`, payload).catch(() => {
            console.log("ux logs-2 not sent");
        })
    }

    const cleanup = () => {
        batchUpdate({
            log_filiale_pos: 0,
            log_filiale_id: "",
            log_filiale_name: "",
            log_filiale_clicks: 0,
            log_date_clicks: 0,
            log_time_clicks: 0,
            log_elapsed: 0,
        })
    }

    return {
addressSearchEvent,
branchSelectionEvent,
cleanup
    };
}

export default useLog;